import React, { createContext, useState, useEffect } from 'react';

export const TransactionContext = createContext();

export const TransactionProvider = ({ children }) => {
  const productDefault = {
    id: '',
    description: '',
    price: 0,
    quantityAvailable: 0,
    description2: '',
    order: 0,
    isHalfPrice: false,
    halfPrice: 0,
    salesStartAt: '',
    salesEndAt: '',
    purchaseMin: 0,
    purchaseMax: 0,
    tag: '',
    installments: 1,
    online: false,
  };

  const loginDefault = {
    language: null,
    country: '',
    email: '',
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRemainingTime((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const [remainingTime, setRemainingTime] = useState(300);
  const transactionResponseDefault = { success: false, data: null };
  const [selectedProduct, setSelectedProduct] = useState(productDefault);
  const [transactionResponse, setTransactionResponse] = useState(
    transactionResponseDefault,
  );
  const [paymentType, setPaymentType] = useState(null);

  const [login, setLogin] = useState(loginDefault);

  const fillLogin = (name, value) =>
    setLogin((prevState) => ({ ...prevState, [name]: value }));

  const [language, setLanguage] = useState(null);
  const [country, setCountry] = useState(null);

  const transactionContextValue = {
    productDefault,
    selectedProduct,
    setSelectedProduct,
    transactionResponse,
    setTransactionResponse,
    paymentType,
    setPaymentType,
    remainingTime,
    setRemainingTime,
    language,
    setLanguage,
    country,
    setCountry,
    login,
    fillLogin,
  };

  return (
    <TransactionContext.Provider value={transactionContextValue}>
      {children}
    </TransactionContext.Provider>
  );
};
